import styled from 'styled-components';

const GameStyle = styled.div`
	&.game {
		--diff: calc(var(--titleWrapMargin) + var(--headerHeight));

		opacity: 0;

		position: absolute;
		top: calc(-1 * var(--diff));
		left: 50%;
		width: 100vw;
		height: calc(100% + var(--diff));
		transform: translate3d(-50%, 0, 0);
		// pointer-events: none;

		.pointCont {
			position: absolute;
			bottom: var(--sp2x);
			left: 50%;
			transform: translate3d(-50%, 0, 0);
			display: flex;
			flex-direction: column;
			align-items: flex-end;
			text-align: right;
		}

		canvas {
			pointer-events: none;
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			.pointCont {
				bottom: var(--sp4x);
				align-items: flex-start;
				text-align: left;
			}
		}
	}
`;

export default GameStyle;
